import React from 'react';
import { IconButton } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import { formatBRL } from '../packageFormat';
import styles from './ProcedurePicker.module.css';

/** Um procedimento com o contador de sessões (menos, número digitável, mais). */
function ProcedureCard({ procedure, quantity, onChange }) {
  const selected = quantity > 0;
  const unit = Number(procedure.Price || 0);
  // eslint-disable-next-line eqeqeq
  const inactive = procedure.Active == 0;

  const handleTyping = (event) => {
    const { value } = event.target;
    if (value === '' || /^\d+$/.test(value)) onChange(value === '' ? 0 : parseInt(value, 10));
  };

  return (
    <div className={`${styles.card} ${selected ? styles.selected : ''}`}>
      <div className={styles.cardTop}>
        <span className={styles.check} aria-hidden="true">
          {selected ? <CheckRoundedIcon /> : <MedicalServicesOutlinedIcon />}
        </span>
        <span className={styles.cardText}>
          <span className={styles.label} title={procedure.Label}>{procedure.Label}</span>
          <span className={styles.unit}>
            {formatBRL(unit)} cada
            {inactive && <span className={styles.inactive}> · inativo</span>}
          </span>
        </span>
      </div>

      <div className={styles.cardBottom}>
        <div className={styles.stepper}>
          <IconButton
            size="small"
            className={styles.stepButton}
            onClick={() => onChange(quantity - 1)}
            disabled={!selected}
            aria-label={`Uma sessão a menos de ${procedure.Label}`}
          >
            <RemoveRoundedIcon fontSize="small" />
          </IconButton>
          <input
            className={styles.qty}
            inputMode="numeric"
            value={quantity || ''}
            placeholder="0"
            onChange={handleTyping}
            aria-label={`Sessões de ${procedure.Label}`}
          />
          <IconButton
            size="small"
            className={styles.stepButton}
            onClick={() => onChange(quantity + 1)}
            aria-label={`Uma sessão a mais de ${procedure.Label}`}
          >
            <AddRoundedIcon fontSize="small" />
          </IconButton>
        </div>
        {selected && <span className={styles.subtotal}>{formatBRL(unit * quantity)}</span>}
      </div>
    </div>
  );
}

/** Grade dos procedimentos da empresa para escolher quantas sessões de cada entram no pacote. */
function ProcedurePicker({ procedures, selected, onChange }) {
  // Só ativos entram como opção; um inativo que o pacote já tem continua visível, marcado
  const visible = procedures.filter((procedure) => (
    // eslint-disable-next-line eqeqeq
    procedure.Active != 0 || selected.some((p) => p.procedure_id == procedure.Id)
  ));

  if (visible.length === 0) {
    return (
      <div className={styles.empty}>
        <MedicalServicesOutlinedIcon fontSize="small" />
        Cadastre procedimentos primeiro para montar um pacote.
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {visible.map((procedure) => {
        // eslint-disable-next-line eqeqeq
        const current = selected.find((p) => p.procedure_id == procedure.Id);
        return (
          <ProcedureCard
            key={procedure.Id}
            procedure={procedure}
            quantity={current?.quantity || 0}
            onChange={(quantity) => onChange(procedure, quantity)}
          />
        );
      })}
    </div>
  );
}

export default ProcedurePicker;
